import { createSelector } from '@reduxjs/toolkit';

import { type TJsonQuery } from '@/packages/JsonQuery';
import { type SortType } from '@/packages/api-models/common/json_query';

import { useReduxSelector } from '../../../hooks';
import { type MapBounds } from '../../mapConfiguration/slice';

import { jsonQuerySelector } from './root';

export const listingSortSelector = createSelector(jsonQuerySelector, state => state.sort);

export function useListingSortSelector(): SortType {
  return useReduxSelector(listingSortSelector);
}

export const filtersSelector = createSelector(jsonQuerySelector, state => state.filters);
export function useFiltersSelector(): TJsonQuery {
  return useReduxSelector(filtersSelector);
}

export const filtersBboxSelector = createSelector(filtersSelector, state => state.bbox?.value);
export function useFiltersBboxSelector(): MapBounds | undefined {
  return useReduxSelector(filtersBboxSelector);
}

export const pageSelector = createSelector(jsonQuerySelector, state => state.page);
export function usePageSelector(): number {
  return useReduxSelector(pageSelector);
}

export const needUpdateQueryKeySelector = createSelector(jsonQuerySelector, state => state.needUpdateQueryKey);
export function useNeedUpdateQueryKeySelector(): boolean {
  return useReduxSelector(needUpdateQueryKeySelector);
}

export const queryKeySelector = createSelector(jsonQuerySelector, state => state.queryKey);
export function useQueryKeySelector(): string[] {
  return useReduxSelector(queryKeySelector);
}
